/** The root Redux store, as far as the auth boundary needs it. */
export interface RootAuthStore {
  dispatch: (action: { type: string; payload?: unknown }) => unknown;
  getState: () => object;
}

let appRootStore: RootAuthStore | null = null;

/**
 * Hosts the app-wide auth boundary's state in the root store, under `AUTH_SLICE_NAME` (T094).
 * `src/redux/store.tsx` calls this right after creating the store. Binding by injection keeps
 * `auth-boundary.ts` free of a `redux/store` import, which would close a cycle through
 * `shared/apollo.ts`.
 */
export function bindAppAuthStore(store: RootAuthStore): void {
  appRootStore = store;
}

export function getBoundAppAuthStore(): RootAuthStore | null {
  return appRootStore;
}
